<template>
  <div
    class="player"
    id="player"
  >
    <video
      class="video"
      v-if="mobile=='android'"
      id="video"
      width="100%"
      height="100%"
      preload="none"
      :src="videoSrc"
      controls
      controlslist="nofullscreen"
      contentType="video/mp4"
      :playOrPause="playOrPause"
      notSupportedMessage:='此视频暂无法播放，请稍后再试'
      @click="pauseVideo"
    >
    </video>
    <video
      class="video"
      v-if="mobile=='iPhone'"
      id="video"
      width="100%"
      height="100%"
      controls
      controlslist="nofullscreen"
      preload="none"
      webkit-playsinline
      playsinline="true"
      :src="videoSrc"
      :playOrPause="playOrPause"
      notSupportedMessage:='此视频暂无法播放，请稍后再试'
      @click="pauseVideo"
      @mousedown="pauseVideo"
      @touchend="pauseVideo"
      @tap="pauseVideo"
    >
    </video>
  </div>
</template>
<style lang="">
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
</style>
<script>
let video
export default {
  components: {},
  data () {
    return {
      vObj: null,
      playOrPause: false,
      videoPic: '',
      videoSrc: '',
      mobile: ''
    }
  },
  created () {
    this.vObj = JSON.parse(this.$route.query.videoObj)
    this.videoPic = this.vObj.magePath
    this.videoSrc = this.vObj.filePath
    this.mobile =
      navigator.appVersion.indexOf('iPhone') !== -1 ? 'iPhone' : 'android'
  },
  mounted () {
    video = document.querySelector('#video')
    this.transformVideo(video)
  },
  methods: {
    pauseVideo () {
      // 暂停\播放
      this.transformVideo(video)
      if (this.playOrPause) {
        console.log('ififif-----pausepause')
        video.pause()
      } else {
        console.log('else-----playplayplay')
        video.play()
      }
      this.playOrPause = !this.playOrPause
    },
    transformVideo (video) {
      video.style.width = window.innerHeight + 'px'
      video.style.height = window.screen.availWidth + 'px'
      video.style.transformOrigin = 'left top'
      video.style.transform =
        'translateX(' + window.screen.availWidth + 'px) rotate(90deg)'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/VideoPlay.vue